import { defineStore } from "pinia";

export const usePdvStore = defineStore("pdv", {
    state: () => {
        return {
            order: null,
            hasToShowDetails: false,
            isExactPayment: true,
            tempReceivedAmount: null,
            isDisabled: false,
            categoriesMenu: [],
            // BS-6206: la carta tiene cambios sin guardar, y el tab al que el usuario quiso
            // ir y quedó esperando confirmación. Viven acá porque el switch de tabs está en
            // el layout (ShopFilter), fuera de la página.
            menuHasUnsavedChanges: false,
            pendingTabAction: null,
        };
    },
    getters: {
        getOrder: (state) => state.order,
        getShowDetails: (state) => state.hasToShowDetails,
        getIsExactPayment: (state) => state.isExactPayment,
        getIsDisabled: (state) => state.isDisabled,
        getTempReceivedAmount: (state )=> state.tempReceivedAmount,
        getCategoriesMenu: (state )=> state.categoriesMenu,
        getMenuHasUnsavedChanges: (state) => state.menuHasUnsavedChanges,
        getPendingTabAction: (state) => state.pendingTabAction,
    },
    actions: {
        setOrder(order) {
            this.order = order;
        },
        setIsExactPayment(isExactPayment) {
            this.isExactPayment = isExactPayment;
        },
        setShowDetails(hasToShowDetails) {
            this.hasToShowDetails = hasToShowDetails;
        },
        setIsDisabled(isDisabled) {
            this.isDisabled = isDisabled;
        },
        setTempReceivedAmount(tempReceivedAmount){
            this.tempReceivedAmount = tempReceivedAmount
        },
        setCategoriesMenu(categoriesMenu){
            this.categoriesMenu = categoriesMenu
        },
        setMenuHasUnsavedChanges(menuHasUnsavedChanges){
            this.menuHasUnsavedChanges = menuHasUnsavedChanges
        },
        setPendingTabAction(pendingTabAction){
            this.pendingTabAction = pendingTabAction
        },
    },
});
